import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationModel } from "../../shared/models/notification.model";
import { Subscription } from "rxjs";
import { UserService } from "../../shared/services/user.service";
import { Router } from "@angular/router";
import { HelperService } from "../../shared/services/helper.service";
import * as moment from "moment";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  @Input() notifications: NotificationModel[];
  @Output() reloadNotifications = new EventEmitter<boolean>();
  loading = false;

  private dismiss: Subscription;
  constructor(private userService: UserService,
              private router: Router,
              private helpService: HelperService) { }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    if (this.dismiss) { this.dismiss.unsubscribe(); }
  }

  parseDateFormat(date: string): string {
    return moment(date).fromNow();
  }

  dismissNotification(notification: NotificationModel): void {
    notification.isDismissed = true;
    this.loading = true;
    this.dismiss = this.userService.dismissNotification(notification).subscribe(() => {
      this.loading = false;
      this.reloadNotifications.emit(true);
      this.helpService.openSnackbar('Notification Dismissed.', 'success', 1000);
    }, () => {
      this.loading = false;
      this.helpService.openSnackbar('Notification ERROR: Please try again!', 'error', 1000);
    });
  }

  redirectNotification(notification: NotificationModel): void {
    if (notification.notificationLink && notification.notificationLinkType === 'External') {
      window.open(notification.notificationLink, '_blank')?.focus();
    } else if (notification.notificationLink && notification.notificationLinkType === 'Internal') {
      this.router.navigate([notification.notificationLink]);
    }

    this.dismissNotification(notification);
  }

}
